/**
 * The canonical addresses of the practitioner's pathway screens (contract §9), written in
 * the platform tree's spelling ("/admin/..."): every caller passes them through
 * `adminHref` (admin/adminPath.js), which re-roots them onto the current console base.
 */
const enc = encodeURIComponent;
const base = "/admin/pathways";

export const BUILDER_STEPS = Object.freeze(["basics", "structure"]);

export const pathwayPaths = Object.freeze({
  list: base,
  create: `${base}/new`,
  /** @param {string} id  @param {"basics"|"structure"} [step] */
  edit: (id, step) => `${base}/${enc(id)}/edit${step ? `?step=${step}` : ""}`,
  dashboard: (id) => `${base}/${enc(id)}`,
  /** @param {string} id  @param {string} [stepId] a step screen of the preview */
  preview: (id, stepId) => `${base}/${enc(id)}/preview${stepId ? `?step=${enc(stepId)}` : ""}`,
  /** The CRM record of a learner, opened on its Pathways tab at this pathway. */
  crmContact: (email, pathwayId) => `/admin/crm?contact=${enc(email)}&tab=pathways&pathway=${enc(pathwayId)}`,
});
